import { render } from "./LayoutNewDesign.vue?vue&type=template&id=107a9e4d&scoped=true"
import script from "./LayoutNewDesign.vue?vue&type=script&lang=js"
export * from "./LayoutNewDesign.vue?vue&type=script&lang=js"

import "./LayoutNewDesign.vue?vue&type=style&index=0&id=107a9e4d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107a9e4d"]])

export default __exports__